import React, { useEffect } from 'react';
import { Box } from '@material-ui/core'
import Step2 from './Steps/Step2';
import Step3 from './Steps/Step3';
import Step1 from './Steps/Step1';
import AddNewClientModal from './AddNewClientModal';

interface QuickBookStepProps {
    currentStep: number,
    updatedSteps: any[],
    setUpdateSteps: any,
    setFetchingQuickbooks: (fetchingQuickbooks: boolean) => void,
    setCurrentStep: (currentStep: number) => void,
    importedClients: any[],
    setImportedClients: (importedClients: any[]) => void,
    history: any,
    allClients: any[],
    setAllClients: (allClients: any[]) => void,
    addNewClientModal: boolean,
    setAddNewClientModal: (open: boolean) => void,
    addClientsManually: boolean,
    setAddClientsManually: (addClientsManually: boolean) => void,
    showExistingUsersWarning: boolean,
    setShowExistingUsersWarning: (show: boolean) => void,
    importedClientsCount: string | null,
    setImportedClientsCount: (count: string | null) => void,
};

const QuickBooksSteps = ({
    currentStep,
    updatedSteps,
    setUpdateSteps,
    setFetchingQuickbooks,
    setCurrentStep,
    importedClients,
    setImportedClients,
    history,
    allClients,
    setAllClients,
    addNewClientModal,
    setAddNewClientModal,
    addClientsManually,
    setAddClientsManually,
    showExistingUsersWarning,
    setShowExistingUsersWarning,
    importedClientsCount,
    setImportedClientsCount,
}: QuickBookStepProps) => {

    useEffect(() => {
        if (importedClients.length > 0 || allClients.length > 0) {
            setUpdateSteps(prev =>
                prev.map(obj =>
                    obj.number === 2 ? { ...obj, completed: true } : obj
                ));
            setCurrentStep(2);
        }
    }, [importedClients, allClients, setCurrentStep, setUpdateSteps]);

    const onClickAddClient = (client: { firstName: string; lastName: string; email: string; company: string }) => {
        const newClients = [client, ...importedClients];
        setImportedClients(newClients);
        setAllClients(newClients);
        setAddClientsManually(true);
        setAddNewClientModal(false);
    }

    return (
        <Box sx={{ width: '100%'}}>
            {currentStep === 1 &&
                <Step1
                    setImportedClients={setImportedClients}
                    history={history}
                    setUpdateSteps={setUpdateSteps}
                    setCurrentStep={setCurrentStep}
                    setFetchingQuickbooks={setFetchingQuickbooks}
                    setAllClients={setAllClients}
                    setAddNewClientModal={setAddNewClientModal}
                />}
            {currentStep === 2 &&
                <Step2
                    importedClients={importedClients}
                    setImportedClients={setImportedClients}
                    setAllClients={setAllClients}
                    setUpdateSteps={setUpdateSteps}
                    setFetchingQuickbooks={setFetchingQuickbooks}
                    setCurrentStep={setCurrentStep}
                    allClients={allClients}
                    addClientsManually={addClientsManually}
                    showExistingUsersWarning={showExistingUsersWarning}
                    setShowExistingUsersWarning={setShowExistingUsersWarning}
                    importedClientsCount={importedClientsCount}
                    setImportedClientsCount={setImportedClientsCount}
                    setAddNewClientModal={setAddNewClientModal}
                />}
            {currentStep === 3 &&
                <Step3 />
            }
            {addNewClientModal && (
                <AddNewClientModal
                    open={addNewClientModal}
                    onClose={() => setAddNewClientModal(false)}
                    onClickAddClient={onClickAddClient}
                />
            )}
        </Box>
    )
}

export default QuickBooksSteps;